import { AutoAwesomeOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import type { DocumentType } from '@/gql';
import { graphql } from '@/gql';
import { useTrackIntercomEvent } from '@/hooks/useTrackIntercomEvent';
import { useAssistant } from '@/modules/assistant/context/AssistantContext';

const ASK_AI_ASSISTANT_MENU_ITEM_FILE_FRAGMENT = graphql(`
  fragment askAiAssistantMenuItemFileFields on File {
    _id
    filename
    owner {
      ... on Service {
        _id
        machineName
      }
      ... on Group {
        _id
        machineName
      }
    }
  }
`);

interface Props {
  file: DocumentType<typeof ASK_AI_ASSISTANT_MENU_ITEM_FILE_FRAGMENT>;
  onClose: () => void;
}

export const AskAiAssistantMenuItem = ({ file, onClose }: Props) => {
  const { openWithFileIds } = useAssistant();

  const trackIntercomEvent = useTrackIntercomEvent();

  const { _id: fileId, filename, owner } = file;

  const groupId = owner?._id ?? '';
  const machineName = owner?.machineName ?? '';

  if (!fileId) {
    return null;
  }

  return (
    <MenuItem
      onClick={() => {
        openWithFileIds([fileId]);
        trackIntercomEvent(
          `Clicked 'Ask AI Assistant' Button for a file in documents area`,
          { fileId, filename: filename ?? '', groupId, machineName },
        );
        onClose();
      }}
    >
      <ListItemIcon>
        <AutoAwesomeOutlined />
      </ListItemIcon>
      <ListItemText primary="Ask AI Assistant" />
    </MenuItem>
  );
};
